
import { MapTo } from '@adobe/aem-react-editable-components';
import MidPagePromo, { MidPagePromoEditConfig } from './MidPagePromo';

export default MapTo('cob-corp-acquisition/components/creditonebank/mid-page-promo')(MidPagePromo, MidPagePromoEditConfig);
        